<a href="https://sitemate.com" class="sitemate-logo" rel="noopener noreferrer">
  <img
    src="assets/images/sitemate-logo.svg"
    alt="Sitemate"
    class="sm-w-legacy-25.6"/>
</a> 

<form
  data-test="user-info-form"
  class="form animate-fade-in"
  name="userInfoForm"
  #userInfoForm="ngForm"
  (ngSubmit)="submitDetails()"
>
  <h1 data-test="heading-text" class="heading-text" i18n *ngIf="isTemplateReferral">
    Use your smart template for free
  </h1>
  <h1 data-test="heading-text" class="heading-text" i18n *ngIf="isNonTemplateReferral">
    Create your free Dashpivot account
  </h1>
  <p class="sm-text-center subtitle-text" i18n>No credit card required</p>

  <div class="form-group">
    <div class="email-container">
      <input
        type="email"
        i18n-placeholder="Email"
        placeholder="Email"
        class="form-control form-input"
        [class.error-state]="hasFormError(email)"
        ccUniqueEmail="true"
        [expectedPattern]="emailRegex"
        autocomplete="off"
        #email="ngModel"
        id="signup-email"
        name="email"
        required
        email
        [(ngModel)]="model.email"
        (ngModelChange)="verifyEmail(email)"
        [disabled]="shouldShowFieldsBelowEmail"
      />
    </div>
    <div *ngIf="hasFormError(email)" class="sm-mt-1 sm-text-xs sm-text-default-red" id="email-danger">
      <div *ngIf="email.errors?.required" i18n>Required</div>
      <div *ngIf="hasEmailFormattingError(email)" i18n>
        Please enter your email address in the format name@example.com
      </div>
      <div *ngIf="email.errors?.uniqueEmail && !email.errors.uniqueEmail?.invalidFormat" i18n>
        This email has already been used, please check your inbox and junk for an invitation link, or
        <a routerLink="/login">sign in</a> here.
      </div>
    </div>
  </div>

  <div data-test="user-details" [hidden]="!shouldShowFieldsBelowEmail" [@slideInOut]="shouldShowFieldsBelowEmail">
    <div class="form-group">
      <div class="row">
        <div class="pr-1 col">
          <input
            type="text"
            i18n-placeholder="First name"
            placeholder="First name"
            class="form-control form-input sm-capitalize"
            [class.error-state]="hasFormError(firstName)"
            #firstName="ngModel"
            name="firstName"
            id="signup-first-name"
            [(ngModel)]="model.firstName"
            [pattern]="doNotAcceptWithoutAlphanumeric"
            required
            autofocus
          />
          <div class="sm-mt-1 sm-text-default-red" i18n *ngIf="hasFormError(firstName)">Required</div>
        </div>
        <div class="pl-1 col">
          <input
            type="text"
            i18n-placeholder="Last name"
            placeholder="Last name"
            class="form-control form-input sm-capitalize"
            [class.error-state]="hasFormError(lastName)"
            #lastName="ngModel"
            name="lastName"
            id="signup-last-name"
            [(ngModel)]="model.lastName"
            [pattern]="doNotAcceptWithoutAlphanumeric"
            required
          />
          <div class="sm-mt-1 sm-text-default-red" i18n *ngIf="hasFormError(lastName)">Required</div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <input
        type="text"
        i18n-placeholder="Company name"
        placeholder="Company name"
        [class.error-state]="hasFormError(companyName)"
        #companyName="ngModel"
        class="form-control form-input"
        id="signup-company"
        name="company"
        required
        [(ngModel)]="model.companyName"
        [pattern]="doNotAcceptWithoutAlphanumeric"
      />
      <div
        class="sm-mt-1 sm-text-xs sm-text-default-red"
        i18n
        *ngIf="hasFormError(companyName)"
        data-test="company-danger"
      >
        Company name should have one or more alphanumeric characters.
      </div>
    </div>
    <div class="form-group">
      <cc-tool-tip
        *ngIf="isSSODomain; else passwordContainer"
        [contentText]="disabledPasswordToolTip"
        containerClass="sm-inline-block sm-w-full"
      >
        <ng-container *ngTemplateOutlet="passwordContainer"></ng-container>
      </cc-tool-tip>

      <ng-template #passwordContainer>
        <div class="password-container" [class.disabled]="isSSODomain">
          <input
            [type]="showPassword ? 'text' : 'password'"
            i18n-placeholder="Password"
            placeholder="Password"
            class="form-control password form-input"
            [class.error-state]="hasFormError(password)"
            id="signup-password"
            name="password"
            [pattern]="combinedPasswordValidationRegex"
            [disabled]="isSSODomain"
            [required]="!isSSODomain"
            [(ngModel)]="model.password"
            #password="ngModel"
            autocomplete="current-password"
            (input)="onPasswordChange($event.target.value)"
          />
          <span class="password-toggle" (click)="showPassword = !showPassword">
            <i class="fa fa-eye-slash" [class.fa-eye-slash]="!showPassword" [class.fa-eye]="showPassword"></i>
          </span>
        </div>
        <div *ngIf="hasFormError(password) && !isSSODomain">
          <cc-password-validation-list [passwordValidation]="passwordValidation"></cc-password-validation-list>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="btn-submit-container">
    <button
      type="submit"
      id="btn-submit-form-1"
      class="button-large button-blue"
      ccSegmentCTA
      ctaContext="{{ shouldShowFieldsBelowEmail ? 'Sign Up Get Started' : 'Sign Up Page 1 Email' }}"
      [disabled]="userInfoForm?.form.controls.email?.invalid || (shouldShowFieldsBelowEmail && !userInfoForm.valid)"
      (click)="handleNextClick($event)"
    >
      <span class="sm-text-white" i18n>Next</span>
    </button>
  </div>
</form>
